
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  --initial-height:'max-content';
}

.percentage-card {
  width: 100%;
}

.card-title {
  margin: auto;
  text-align: center;
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
  font-weight: var(--fw-semibold);
  letter-spacing: -0.05em;
  color: var(--neutral-black);
}

.card-title p {
  margin-bottom: 0px;
}

.card-subtitle {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: var(--fw-semibold);
  text-transform: uppercase;
  color: var(--gray-professional-darken-1);
}

.card-subtitle p {
  margin-top: 0px;
}

.card-content {
  position: relative;
}

.graph-wrapper {
  box-sizing: border-box;
  overflow: hidden;
  padding-top: 1rem;
  border-top:3px solid var(--gray-professional-lighten-4);
  height:var(--initial-height);
  transition:height 0.3s ease-in-out;
}

.graph-inner-wrapper {
  box-sizing: border-box;
  padding-bottom: 0.5rem;
}

footer {
  padding-top: 2.5rem;
}

:host([is-expanded="true"]) .graph-wrapper {
  height: 100%;
}

:host([is-expanded="true"]) .graph-wrapper {
  overflow: visible;
}
`;